export const rubyDefaultSource = `# puts calls will be matched by pattern!
# click diff tab to see rewrite.

def process_data(data)
  puts "Processing data: #{data}"
  
  if data.nil?
    puts "Warning: data is nil"
    return false
  end
  
  result = data.transform(&:upcase)
  puts "Result: #{result}"
  
  # This string won't be matched
  message = "puts 'not me'"
  
  # Multiple argument puts
  puts "Status:", "completed"
  
  result
end

class DataProcessor
  def initialize(name)
    @name = name
    puts "Created processor: #{@name}"
  end
  
  def log_status
    puts "Processor #{@name} is ready"
  end
end`;

export const rubyDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";
import type Ruby from "@ast-grep/napi/lang/ruby";

async function transform(root: SgRoot<Ruby>): Promise<string> {
  const rootNode = root.root();

  const nodes = rootNode.findAll({
    rule: {
      pattern: "puts $ARGS",
    },
  });

  const edits = nodes.map(node => {
    const args = node.getMatch("ARGS").text();
    return node.replace(\`logger.info(\${args})\`);
  });

  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const rubyDefaultConfig = `# Codemod Studio uses ast-grep to match and rewrite code.
# https://ast-grep.github.io/guide/rule-config.html#rule
id: replace-puts-with-logger
language: ruby
rule:
  pattern: puts $$$ARGS
fix:
  logger.info($$$ARGS)
`;
